// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS } from "constants/styleVariables";

export const DiscountCardContainer = styled.div(
  ({ background }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 60px 0px 20px;
    width: 360px;
    height: 180px;
    background: ${background ? background : COLORS.secondarygradientBlueColors};
    box-shadow: ${BOXSHADOW.discountCardsBoxShadow};
    border-radius: 15px;
    margin-bottom: 40px;
    cursor: pointer;
    position: relative;
  `
);
export const DiscountDetails = styled.div(
  ({ opacity }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 180px;
    opacity: ${opacity ? opacity : 1};
  `
);
export const Title = styled.text`
  font-size: 20px;
  color: ${COLORS.primaryWhite};
  margin-bottom: 10px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
`;
export const Amount = styled.text`
  font-size: 24px;
  color: ${COLORS.primaryWhite};
  font-weight: 600;
  font-family: ${FONTS.montserrat};
`;
export const Type = styled.text`
  font-size: 14px;
  color: ${COLORS.primaryWhite};
  margin-bottom: 5px;
  font-family: ${FONTS.montserrat};
  font-weight: 600;
`;
export const DiscountContainer = styled.div`
  padding: 13px 25px;
  color: ${COLORS.forthBlack};
  background: ${COLORS.backgroundColor};
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  font-family: ${FONTS.montserrat};
  font-weight: bold;
  position: relative;
`;
export const LogoIcon = styled.img(
  ({ opacity }) => css`
    opacity: ${opacity ? opacity : 1};
  `
);

export const DeleteButton = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  right: 20px;
  bottom: 20px;
  cursor: pointer;
  z-index: 1000;
`;
